import { render, staticRenderFns } from "./VhostManagePanel.vue?vue&type=template&id=0cb79ee3&scoped=true&"
import script from "./VhostManagePanel.vue?vue&type=script&lang=ts&"
export * from "./VhostManagePanel.vue?vue&type=script&lang=ts&"
import style0 from "./VhostManagePanel.vue?vue&type=style&index=0&id=0cb79ee3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb79ee3",
  null
  
)

export default component.exports